require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.promise');
module.exports = require('../modules/_core').Promise;



//////////////////
// WEBPACK FOOTER
// /Users/JOTO/Documents/www/herok-2017/site/node_modules/core-js/es6/promise.js
// module id = ../../node_modules/core-js/es6/promise.js
// module chunks = 0